import * as ng from 'angular';
import {ArchiSmallServices} from '../../../services/archismall.service';

class ConsumiModalController implements ng.IController {

  static $inject: string[] = [
    '$rootScope',
    '$scope',
    'ArchiSmallServices'
  ];

  private close: any;

  constructor(
    private $rootScope: any, // ng.IRootScopeService,
    private $scope: any, // ng.IScope,
    private ArchiSmallServices: ArchiSmallServices
  ) {
    $scope.isUsagePercentage = true;
    $scope.options = {
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            const label = data.labels[tooltipItem.index] || '';
            const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return `${label}: ${value} %`;
          }
        }
      }
    };

    $scope.close = () => {
      this.close();
    };
    if ($scope.$parent.$resolve.settings.typeLimit === 'CE') {
      $scope.year = `anno ${new Date().getFullYear()}`;
      $scope.typeLimit = $scope.$parent.$resolve.settings.typeLimit;
      $scope.freePercentage = $rootScope.storageUsage.usagePercentage <= 100 ? 100 - $rootScope.storageUsage.usagePercentage : $scope.isUsagePercentage = false;
      $scope.availableSpace = parseFloat($rootScope.storageUsage.availableSpace.replace(' MB', ''));
      $scope.usedSpace = $rootScope.storageUsage.dataSize[0] + $rootScope.storageUsage.dataSize[1];
      $scope.showAlertWarning = $scope.usedSpace > ($scope.availableSpace * 0.8);
      $scope.showAlertWarningTypeLimit = 'Consumi CE: ';
      $scope.consumiData = [
        {'class': 'consumi-archivia-bgrd', 'label': 'Archivia', 'storage': $rootScope.storageUsage.dataSize[1]},
        {'class': 'consumi-conserva-bgrd', 'label': 'Conservazione', 'storage': $rootScope.storageUsage.dataSize[0]},
        {'class': 'consumi-free-bgrd', 'label': 'Libero', 'storage': $rootScope.storageUsage.dataSize[2]}
      ];
    }
    if ($scope.$parent.$resolve.settings.typeLimit === 'PEC') {
      $scope.typeLimit = $scope.$parent.$resolve.settings.typeLimit;
      $scope.year = '';
      $scope.freePercentage = $rootScope.storageUsage.usagePercentagePEC <= 100 ? 100 - $rootScope.storageUsage.usagePercentagePEC : $scope.isUsagePercentage = false;
      $scope.availableSpacePEC = parseFloat($rootScope.storageUsage.availableSpacePEC.replace(' MB', ''));
      $scope.usedSpace = $rootScope.storageUsage.dataSize[0];
      $scope.showAlertWarning = $scope.usedSpace > ($scope.availableSpacePEC * 0.8);
      $scope.showAlertWarningTypeLimit = 'Consumi PEC: ';
      $scope.availableSpace = $rootScope.storageUsage.availableSpacePEC;
      $scope.consumiData = [
        {'class': 'consumi-pec-bgrd', 'label': 'PEC', 'storage': $rootScope.storageUsage.dataSize[0]},
        {'class': 'consumi-free-bgrd', 'label': 'Libero', 'storage': $rootScope.storageUsage.dataSize[1]}
      ];
    }

    $scope.getModulo = (index: any) => {
      return index % 2;
    };
  }
}

export const ConsumiModalComponent: ng.IComponentOptions = {
  template: require('./consumi-modal.html'),
  controller: ConsumiModalController,
  bindings: {
    close: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/consumi-modal/consumi-modal.ts